import React, { lazy, Suspense, useState } from "react";
import logo from "../../../assets/images/logo.png";
import { NavItems } from "../../../data/dummyData";
import { Link } from "react-router-dom";
import { MdShoppingBasket } from "react-icons/md";
import Avatar from "../../../assets/images/avatar.png";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../../../app/firebase/firebase.config";
import { motion } from "framer-motion";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
} from "../../../app/store/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import CartContainer from "./CartContainer";

// Lazy loaded components
const UserPhoto = lazy(() => import("./UserPhoto"));
const UserMenu = lazy(() => import("./UserMenu"));

const Header = () => {
  const dispatch = useDispatch();
  const firebaseAuth = getAuth(app);
  const provider = new GoogleAuthProvider();

  const { cartItems } = useSelector((state) => state.cart);
  const cartQTY = cartItems.length;

  const user = useSelector((state) => state.auth.user);
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [openCart, setOpenCart] = useState(false);

  const showCart = () => {
    setOpenCart(!openCart);
  };

  const loginHandler = async () => {
    if (!user) {
      try {
        dispatch(loginStart());

        const response = await signInWithPopup(firebaseAuth, provider);
        const user = response.user;

        const data = {
          accessToken: user.accessToken,
          displayName: user.displayName,
          email: user.email,
          emailVerified: user.emailVerified,
          isAnonymous: user.isAnonymous,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
          providerId: user.providerId,
          providerData: user.providerData[0],
          reloadUserInfo: user.reloadUserInfo,
          refreshToken: user.stsTokenManager.refreshToken,
        };
        //const { refreshToken, providerData } = data;

        dispatch(loginSuccess(data));
      } catch (error) {
        console.error(error);
        dispatch(loginFailure(error.message));
      }
    } else {
      setOpenUserMenu((prev) => !prev);
    }
  };

  const logoutHandler = () => {
    dispatch(logout());
    setOpenUserMenu(false);
  };

  return (
    <>
      <header className="fixed m-auto z-50  p-3 md:p-6 px-4 md:px-16 w-screen  bg-primary">
        {/* Desktop and Tabels */}
        <div className="hidden md:flex w-full h-full p-4 justify-between ">
          <Link to="/">
            <div className="flex items-center gap-2">
              <img src={logo} className="w-8 cursor-pointer" alt="logo" />
              <p className=" text-headingColor cursor-pointer text-xl font-bold">
                City
              </p>
            </div>
          </Link>

          <nav className="flex items-center gap-8">
            <motion.ul
              initial={{ opacity: 0, x: 200 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 200 }}
              className="flex items-center gap-8 "
            >
              {NavItems.map((navItem, idx) => (
                <Link to={navItem.link} key={idx}>
                  <li className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer ">
                    {navItem.name}
                  </li>
                </Link>
              ))}
            </motion.ul>
            <div className="  flex items-center justify-center gap-5">
              <div
                onClick={showCart}
                className="flex items-center justify-center relative"
              >
                <MdShoppingBasket className=" text-textColor text-2xl cursor-pointer " />
                <div className=" absolute p-3 w-4 h-4 rounded-full bg-cartNumBg -top-4 -right-4 flex items-center justify-center ">
                  <p className=" text-xs text-white font-semibold ">{cartQTY}</p>
                </div>
              </div>
              <div className=" relative">
                <Suspense fallback={<div>Loading Avatar...</div>}>
                  <UserPhoto
                    photoURL={user ? `${user.photoURL}` : Avatar}
                    onClick={loginHandler}
                  />
                </Suspense>
                {openUserMenu && (
                  <Suspense fallback={<div>Loading UserMenu...</div>}>
                    <UserMenu
                      menuHandler={() => {
                        setOpenUserMenu(false);
                      }}
                      email={user.email}
                      logoutHandler={logoutHandler}
                    />
                  </Suspense>
                )}
              </div>
            </div>
          </nav>
        </div>

        {/* Mobile */}
        <div className="flex items-center justify-between md:hidden w-full h-full p-4 ">
          <div
            onClick={showCart}
            className="flex items-center justify-center relative"
          >
            <MdShoppingBasket className=" text-textColor text-2xl cursor-pointer " />
            <div className=" absolute p-3 w-4 h-4 rounded-full bg-cartNumBg -top-4 -right-4 flex items-center justify-center ">
              <p className=" text-xs text-white font-semibold ">{cartQTY}</p>
            </div>
          </div>

          <Link to="/">
            <div className="flex items-center gap-2">
              <img src={logo} className="w-8 cursor-pointer" alt="logo" />
              <p className=" text-headingColor cursor-pointer text-xl font-bold">
                City
              </p>
            </div>
          </Link>

          <div className=" relative">
            <Suspense fallback={<div>Loading Avatar...</div>}>
              <UserPhoto
                photoURL={user ? `${user.photoURL}` : Avatar}
                onClick={loginHandler}
              />
            </Suspense>

            {openUserMenu && (
              <Suspense fallback={<div>Loading UserMenu...</div>}>
                <UserMenu email={user.email} logoutHandler={logoutHandler} />
              </Suspense>
            )}
          </div>
        </div>
      </header>
      {openCart && (
        <CartContainer showCart={showCart} loginHandler={loginHandler} />
      )}
    </>
  );
};

export default Header;
